import { getCompanyLegacyId, getToken } from ".";
import { HttpException } from "../../models/exceptions";
import { MailTemplatePath } from "../../models/mail-template";

// ### Fetching mail template configs for a certain path: event/action/target
export async function fetchMailTemplateConfig({
  signal,
  mailTemplatePath,
}: {
  signal: any;
  mailTemplatePath: MailTemplatePath;
}) {
  const companyLegacyId = await getCompanyLegacyId();
  const token = await getToken();
  const { event, action, target } = mailTemplatePath;

  let url = `${
    (window as any)._env_.REACT_APP_COLIBRY_SERVICES_HOST
  }/api/2/customers/${companyLegacyId}/mail-templates/config/event/${event}/action/${action}/target/${target}`;

  const response = await fetch(url, {
    signal: signal,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new HttpException("An error occurred while fetching the templates.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  let templateConfigs = await response.json();
  templateConfigs = templateConfigs.map((t: any) => ({
    ...t,
    event,
    action,
    target,
  }));

  return templateConfigs.length > 0 ? templateConfigs[0] : {};
}

export async function saveMailTemplateConfig({
  mailTemplatePath,
  config,
}: {
  mailTemplatePath: MailTemplatePath;
  config: any;
}) {
  const companyLegacyId = await getCompanyLegacyId();
  const token = await getToken();
  const { event, action, target } = mailTemplatePath;

  const url = `${
    (window as any)._env_.REACT_APP_COLIBRY_SERVICES_HOST
  }/api/2/customers/${companyLegacyId}/mail-templates/config/event/${event}/action/${action}/target/${target}`;

  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(config),
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/json",
    },
  });

  if (!response.ok) {
    const error = new HttpException("An error occurred while promoting the template.");
    error.code = response.status;
    error.info = await response.json();
    throw error;
  }

  return true;
}
